import {useDispatch, useSelector} from "react-redux";
import {FIELD_LIST_INPUT_SUSTAINABILITY_RUBI} from "../../utils/input-field-list-static-page";
import {setMainPageErrorMessage, setMainPageRubiDetail} from "../../reducers/main-page.reducer";
import React, {useEffect} from "react";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../reducers/tools.reducer";
import {convertErrorMessage} from "../../utils/general-variable";
import FormGeneralComponent from "../../components/static-page/form-general.component";

const Rubi = () => {
    const dispatch = useDispatch()
    const {rubiDetail, mainPageErrorMessage} = useSelector(state => state.mainPageReducer)
    const {fetching: getRUBI} = useFetch(API.HOMEPAGE_GET_RUBI)
    const {fetching: updateRUBI, isLoading} = useFetch(API.HOMEPAGE_UPDATE_RUBI)
    let fieldListInput = FIELD_LIST_INPUT_SUSTAINABILITY_RUBI
    let showRubi = {
        label: 'RUBI',
        key: 'show_rubi',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setMainPageRubiDetail({[key]: value}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        updateRUBI(rubiDetail).then(response => {
            dispatch(setMainPageErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('RUBI Updated'))
            dispatch(setMainPageRubiDetail(response?.data))
        }).catch(err => {
            dispatch(setMainPageErrorMessage(convertErrorMessage(err)))
        })
    }

    useEffect(() => {
        getRUBI().then(response => {
            dispatch(setMainPageRubiDetail(response?.data))
        })

        return () => {
            dispatch(setMainPageErrorMessage({}))
        }
    }, [])

    return (
        <FormGeneralComponent
            data={rubiDetail}
            switchToggleField={showRubi}
            fieldList={fieldListInput}
            onChange={onChange}
            onSubmitHandler={onSubmitHandler}
            inputClassName={'grid grid-cols-2 gap-x-16 gap-y-4'}
            errorMessage={mainPageErrorMessage}
            isLoading={isLoading}
        />
    )
}

export default Rubi